/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentUpdater
 */
export interface TournamentUpdater {
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdater
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdater
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdater
     */
    updaterName: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdater
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdater
     */
    order: string;
}

/**
 * Check if a given object implements the TournamentUpdater interface.
 */
export function instanceOfTournamentUpdater(value: object): value is TournamentUpdater {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('updaterName' in value) || value['updaterName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function TournamentUpdaterFromJSON(json: any): TournamentUpdater {
    return TournamentUpdaterFromJSONTyped(json, false);
}

export function TournamentUpdaterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentUpdater {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tournamentId': json['tournamentId'],
        'updaterName': json['updaterName'],
        'type': json['type'],
        'order': json['order'],
    };
}

export function TournamentUpdaterToJSON(value?: TournamentUpdater | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'updaterName': value['updaterName'],
        'type': value['type'],
        'order': value['order'],
    };
}

